import { Controller } from '@hotwired/stimulus';

const rotateIntensity = 15;

export default class extends Controller {
	static targets = ['card'];

	connect() {
		this.isTouchDevice = this.isTouchDeviceCheck();
		this.updateEventListeners();

		this.pointerEventListener = this.handlePointerChange.bind(this);
		window.addEventListener('pointerdown', this.pointerEventListener);
	}

	disconnect() {
		window.removeEventListener('pointerdown', this.pointerEventListener);
		this.updateEventListeners();
	}

	handlePointerChange(event) {
		this.isTouchDevice = event.pointerType === 'touch';
		this.updateEventListeners();
	}

	updateEventListeners() {
		if (this.isTouchDevice) {
			this.cardTargets.forEach((target) => {
				target.removeEventListener('mousemove', this.boundMouseMove);
				target.removeEventListener('mouseleave', this.boundMouseLeave);
			});
		} else {
			this.boundMouseMove = this.handleMouseMove.bind(this);
			this.boundMouseLeave = this.handleMouseLeave.bind(this);

			this.cardTargets.forEach((target) => {
				target.addEventListener('mousemove', this.boundMouseMove);
				target.addEventListener('mouseleave', this.boundMouseLeave);
			});
		}
	}

	handleMouseMove(event) {
		const target = event.currentTarget;
		const { width, height, left, top } = target.getBoundingClientRect();

		const x = event.clientX - left;
		const y = event.clientY - top;

		const rotateX = (y / height - 0.5) * rotateIntensity;
		const rotateY = (x / width - 0.5) * -rotateIntensity;

		target.style.transform = `perspective(500px) translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(${rotateX}deg) rotateY(${rotateY}deg) skew(0deg, 0deg)`;
	}

	handleMouseLeave(event) {
		event.currentTarget.style.transform =
			'perspective(500px) translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0) rotateY(0) skew(0deg, 0deg)';
	}

	isTouchDeviceCheck() {
		return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
	}
}
